// Copyright ©️ 2025 eVolve MEP, LLC

/**
 * This is the name we instruct our clients to name their Revit view that contains all their spools.
 *
 * When viewing a Spool in the Web, this is the view on the model we will search for.
 */
export const EvolveWebSpoolView = 'EVOLVE Web Spooling';
export const CloudSpoolingHelpLink = 'https://help-foresite.evolvemep.com/article/gellotky0g';
